import * as React from 'react';
import {
  makeStyles, Button
} from '@material-ui/core';
import { TimeOption } from '../np-types';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100px'
  }
}));

interface TimesListProps {
  title: string;
  time: TimeOption;
  times: TimeOption[];
  handleTimeSelect: (t: TimeOption) => void
  disabled: boolean;
}

export const TimesList = ({
  title, time, times, handleTimeSelect, disabled
}: TimesListProps) => {
  const classes = useStyles();
  const [showMore, setShowMore] = React.useState(false);
  const clippedTimes = React.useMemo(() => {
    if (showMore) {
      return times;
    }
    return times.slice(0, 7);
  }, [showMore, times]);

  return (
    <div className={classes.root}>
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      { clippedTimes.map((opt) => (
        <Button
          disableElevation
          color={time?.date === opt.date ? 'primary' : 'default'}
          onClick={() => handleTimeSelect(opt)}
          variant={time?.date === opt.date ? 'contained' : 'outlined'}
          style={{ marginBottom: '5px' }}
          disabled={disabled}
          key={opt.date} >
          {opt.display}
        </Button>)
      )}
      { !showMore && times.length >= 7 && <Button color='primary' onClick={() => setShowMore(true)}>More...</Button> }
    </div>
  );
};
